document.querySelectorAll('.custom-range').forEach(slider => {
  const valueDisplay = slider.parentElement.querySelector('.range-value');

  function updateSliderUI(value) {
    const min = parseFloat(slider.min) || 0;
    const max = parseFloat(slider.max) || 100;
    const percent = Math.min(((value - min) / (max - min)) * 100, 100);
  
    slider.style.background = `linear-gradient(to right, #007bff ${percent}%, #dce0e5 ${percent}%)`;
    valueDisplay.textContent = value;
  }
  

  // Initialize on page load
  updateSliderUI(slider.value);

  // Update on input
  slider.addEventListener('input', function () {
    updateSliderUI(this.value);
  });
});

